
export default {
  name: 'SectionSubs',
}
